import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { Palette as PaletteIcon } from '@mui/icons-material';
import { useThemeContext } from '../contexts/ThemeContext';

const ThemeSelector = () => {
  const { currentTheme, changeTheme, availableThemes } = useThemeContext();
  
  const themeDisplayNames = {
    retro: 'Retro',
    light: 'Light',
    dark: 'Dark', 
    xbox: 'Xbox',
    ps5: 'PS5'
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 140 }}>
      <PaletteIcon fontSize="small" />
      <FormControl size="small" fullWidth>
        <InputLabel>Theme</InputLabel>
        <Select
          value={currentTheme}
          label="Theme"
          onChange={(e) => changeTheme(e.target.value)}
        >
          {availableThemes.map((theme) => (
            <MenuItem key={theme} value={theme}>
              {themeDisplayNames[theme]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ThemeSelector;